import VersionRenderStyle from "./VersionRenderStyle";
import VersionStyle, { InterlinearNumberStyle } from "./VersionStyle";
import WordStyles from "./WordStyles";

export default class VersionStyles {

    public static default(mergeWith: VersionStyle = {}): VersionStyle {
        return Object.assign(mergeWith, {
            classes: this.mergeClasses(['_Default'], mergeWith)
        });
    }

    public static hebrew(mergeWith: VersionStyle = {}): VersionStyle {
        return Object.assign({
            wordPartSeparator: WordStyles.hebrewPartSeparator
        }, mergeWith, {
            classes: this.mergeClasses(['_Hebrew'], mergeWith)
        });
    }

    public static greek(mergeWith: VersionStyle = {}): VersionStyle {
        return Object.assign(mergeWith, {
            classes: this.mergeClasses(['_Greek'], mergeWith)
        });
    }

    public static parsing(mergeWith: VersionStyle = {}): VersionStyle {
        return Object.assign(mergeWith, {
            classes: this.mergeClasses(['_Parsing'], mergeWith)
        });
    }

    public static transliteration(mergeWith: VersionStyle = {}): VersionStyle {
        return Object.assign(mergeWith, {
            classes: this.mergeClasses(['_Transliteration'], mergeWith)
        });
    }

    public static mergeStyles(style: VersionStyle, renderStyle: VersionRenderStyle): VersionStyle {
        return Object.assign({}, style, {
            allowLexiconLookup: renderStyle.noLexiconLookup ? false : style.allowLexiconLookup,
            interlinearNumberStyle: renderStyle.noInterlinearNumbers ? InterlinearNumberStyle.None : style.interlinearNumberStyle
        });
    }

    private static mergeClasses(classes: string[], style: VersionStyle): string[] {
        if (style.classes) {
            classes = classes.concat(style.classes);
        }
        return Array.from(new Set(classes));
    }
}
